import { render } from "./ActiveWorkBar.vue?vue&type=template&id=f2473056&ts=true"
import script from "./ActiveWorkBar.vue?vue&type=script&lang=ts"
export * from "./ActiveWorkBar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/timitools.webweb.works/client/timitools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__